import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent27001 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                ISO 27001:2013 INFORMATION SECURITY MANAGEMENT SYSTEM{" "}
                <span className="border-b-4 border-[#249742]">CERTIFI</span>
                CATION
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 27001:2013 ISMS is a standard responsible for Information
              Security management System published in October 2005 by
              International Organization of Standardization and the
              International Electrotechnical Commission . It legally defines a
              management system that is meant for information security under
              comprehensive management control.Organizations that claim to have
              adopted ISO/IEC 27001 can therefore be formally audited and
              certified compliant with the standard.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent27001;
